import { NativeModules, Platform } from "react-native";
import i18n from "i18next";

import { LanguageType } from "@libs/i18n";
import { getItem } from "@/utils/storage";

// Get the current language from storage or default to 'en'
// String replacement is to fix issue with escaped quotes
export const getLanguage = (): LanguageType =>
  (getItem<LanguageType>("LANGUAGE_CODE")?.replace(/\\"|"/g, "") ??
    "en") as LanguageType;

export const isRTLLanguage = (lang: string) => lang === "ar";

export const updateWebDirection = (lang: string) => {
  if (Platform.OS !== "web" || typeof document === "undefined") return;

  const direction = isRTLLanguage(lang) ? "rtl" : "ltr";
  document.documentElement.setAttribute("dir", direction);
  document.documentElement.setAttribute("lang", lang);
};

export const changeI18nLanguage = async (lang: LanguageType) => {
  // Web applies the persisted locale on reload.
  if (Platform.OS === "web") {
    updateWebDirection(lang);
    window.location.reload();
    return;
  }

  void i18n.changeLanguage(lang);

  if (Platform.OS === "ios" || Platform.OS === "android") {
    const RNRestart = await import("react-native-restart-newarch");
    if (__DEV__) {
      // Type assertion to ensure DevSettings is properly typed with the reload method
      const devSettings = NativeModules.DevSettings as
        | { reload: () => void }
        | undefined;
      devSettings?.reload();
    } else RNRestart.restart();
  }
};
